const doc = [({"en":({"js":({"admin":({"abilities":({"table":({"access":"Access"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;